<!--
  Sub-modale "Codici QR prodotto" — Diakonix native (v2.11.0 J.4.c).
  Z-index 2200 (sopra confirm-products 2100).
  Cross-use con storico-ordini/product-details-storico (v2.9.0).
-->
@if (openedQRS) {
  <div class="pq-backdrop" (click)="close()">
    <div
      class="pq-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pq-title"
      (click)="$event.stopPropagation()"
    >
      <header class="pq-header">
        <div class="pq-title-block">
          <h2 id="pq-title">🔍 Codici QR</h2>
          @if (product?.op_description) {
            <p class="pq-subtitle">{{ product.op_description }}</p>
          }
        </div>
        <button
          type="button"
          class="pq-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <div class="pq-body">
        @if (order.products[index]?.barcodes?.length > 0) {
          <div class="pq-table">
            <div class="pq-table-head">
              <div class="pq-th">#</div>
              <div class="pq-th">Codice</div>
              <div class="pq-th">Lotto</div>
              <div class="pq-th">Progressivo</div>
            </div>

            <div class="pq-table-body">
              @for (
                barcode of order.products[index].barcodes;
                track barcode.barcode_text || $index;
                let i = $index
              ) {
                @if (barcode.barcode_text !== null) {
                  <div class="pq-row">
                    <div class="pq-td pq-td--index">{{ i + 1 }}</div>
                    <div class="pq-td pq-td--code">
                      <span class="pq-code">{{ barcode.barcode_text }}</span>
                    </div>
                    <div class="pq-td">{{ barcode.lot || '—' }}</div>
                    <div class="pq-td">{{ barcode.progressive || '—' }}</div>
                  </div>
                }
              }
            </div>
          </div>
        } @else {
          <div class="pq-empty">
            <div class="pq-empty__icon">📭</div>
            <p>Nessun codice QR disponibile per questo prodotto.</p>
          </div>
        }
      </div>

      <footer class="pq-footer">
        <button
          type="button"
          class="pq-btn pq-btn--close"
          (click)="close()"
        >
          <i class="bx bx-check"></i>
          Chiudi
        </button>
      </footer>
    </div>
  </div>
}
